export const FeildTypes = {
  Heading: "Header",
  TextInput: "Text",
  SelectInput: "Listbox",
  SelectInputMultiple: "ListboxMultiple",
  AutoCompleteInput: "JobTemplateTitles",
  Button: 3,
  CancelButton: 2,
  TextArea: "TextArea",
  RichTextEditor: "Editor",
  Toggle: "Toggle",
  DatePicker: "DatePicker",
  Avatar: "AvatarImage",
  CountrySelect: "Country",
  ResumeUploader: "Resume",
  Table: "Table",
  TimePicker: "TimePicker",
  TimeZone: "TimeZone",
  ImagePicker: "Image",
  DateTimePicker: "DateTimePicker",
  SelectCompleteInput: "SelectCompleteInput",
  Checkbox: "Checkbox",
  MultiUserSelect : "MultiUserSelect",
  Attachments : "Attachments",
  Phone: "Phone",
  CitySelect: "City",
  Icon: "Icon",
  Hidden: "Hidden",
  InputMask: "InputMask",
  Template: "Template"
};
